/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import { PfTvChart } from '@/screens/custom-elements';
import type { ViewModel } from './view-model';

export function EodView({ m }: { m: ViewModel }) {
  return (
    <div style={{ padding: '24px 12px 40px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {' '}
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px', flexWrap: 'wrap' }}>
        {' '}
        <div style={{ flex: '1', minWidth: '260px' }}>
          {' '}
          <div style={{ display: 'flex', alignItems: 'center', gap: '9px' }}>
            <i className="ph ph-file-text" style={{ fontSize: '18px', color: 'var(--acc-2)' }}></i>
            <span style={{ fontSize: '16px', fontWeight: '500', letterSpacing: '-0.01em' }}>
              End-of-Day Reports
            </span>
            <span
              style={{
                fontSize: '9.5px',
                padding: '2px 9px',
                borderRadius: '99px',
                background: 'color-mix(in srgb, var(--acc-fill) 12%, transparent)',
                color: 'var(--acc)',
                fontWeight: '500',
              }}
            >
              {dc.t(m.eodAcct)}
            </span>
          </div>{' '}
          <div style={{ fontSize: '11.5px', color: 'var(--muted)', marginTop: '4px' }}>
            Daily performance summaries with AI-powered analysis and improvement tips
          </div>{' '}
        </div>{' '}
        <button
          className="scp-84a7026"
          onClick={m.eodGen}
          title={dc.a(m.eodGenLabel)}
          aria-label={dc.a(m.eodGenLabel)}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '7px',
            fontSize: '12px',
            fontWeight: '500',
            padding: '8px 16px',
            borderRadius: '99px',
            border: '1px solid color-mix(in srgb, var(--acc-fill) 55%, transparent)',
            background: 'color-mix(in srgb, var(--acc-fill) 10%, transparent)',
            color: 'var(--acc)',
            cursor: 'pointer',
          }}
        >
          <i className="ph ph-sparkle" style={{ fontSize: '13px' }}></i>
          {dc.t(m.eodGenLabel)}
        </button>{' '}
      </div>{' '}
      <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
        {' '}
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--card-line)',
            boxShadow: 'var(--shadow-card)',
            borderRadius: '16px',
            overflow: 'hidden',
            flex: '0 1 300px',
            minWidth: '240px',
            position: 'sticky',
            top: '12px',
            height: 'calc(100vh - 132px)',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {' '}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '12px 16px',
              borderBottom: '1px solid var(--l6)',
              flex: 'none',
            }}
          >
            <i className="ph ph-calendar-blank" style={{ fontSize: '14px', color: 'var(--acc-2)' }}></i>
            <span style={{ fontSize: '12.5px', fontWeight: '500' }}>Report History</span>
          </div>{' '}
          <div style={{ flex: '1', minHeight: '0', overflowY: 'auto' }}>
            {' '}
            {(m.eodList ?? []).map((r, i158) => (
              <Fragment key={i158}>
                {' '}
                <button
                  className="scp-4f3e86a"
                  onClick={r?.go}
                  aria-label={`Open report for ${dc.s(r?.label)}`}
                  aria-pressed={dc.b(r?.sel)}
                  style={dc.css(
                    `display:flex;align-items:center;gap:10px;width:100%;text-align:left;padding:11px 16px;border:none;border-left:2px solid ${dc.s(r?.markBd)};border-bottom:1px solid var(--l5);background:${dc.s(r?.rowBg)};color:var(--text);cursor:pointer`,
                  )}
                >
                  {' '}
                  <div style={{ flex: '1', minWidth: '0' }}>
                    {' '}
                    <div
                      style={{
                        fontSize: '11.5px',
                        fontWeight: '500',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {dc.t(r?.label)}
                    </div>{' '}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        marginTop: '3px',
                        flexWrap: 'wrap',
                      }}
                    >
                      {' '}
                      <span
                        style={dc.css(
                          `font-size:10.5px;color:${dc.s(r?.pnlFg)};font-variant-numeric:tabular-nums`,
                        )}
                      >
                        {dc.t(r?.pnl)}
                      </span>{' '}
                      <span
                        style={{
                          fontSize: '10.5px',
                          color: 'var(--muted)',
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {dc.t(r?.trades)}
                      </span>{' '}
                      <span
                        style={{
                          fontSize: '10px',
                          padding: '1px 6px',
                          borderRadius: '5px',
                          background: 'var(--l6)',
                          color: 'var(--text-mid)',
                        }}
                      >
                        {dc.t(r?.acct)}
                      </span>{' '}
                    </div>{' '}
                  </div>{' '}
                  <span
                    style={dc.css(
                      `font-size:10px;font-weight:600;padding:2px 8px;border-radius:99px;border:1px solid ${dc.s(r?.discBd)};color:${dc.s(r?.discBd)};font-variant-numeric:tabular-nums;flex:none`,
                    )}
                  >
                    {dc.t(r?.disc)}
                  </span>{' '}
                  <i
                    className="ph ph-caret-right"
                    style={{ fontSize: '12px', color: 'var(--faint)', flex: 'none' }}
                  ></i>{' '}
                </button>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
        </div>{' '}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', minWidth: '0', flex: '1 1 0' }}>
          {' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px',
              display: 'flex',
              alignItems: 'flex-start',
              gap: '14px',
              flexWrap: 'wrap',
            }}
          >
            {' '}
            <div style={{ flex: '1', minWidth: '200px' }}>
              {' '}
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                <i className="ph ph-calendar-blank" style={{ fontSize: '13px', color: 'var(--muted2)' }}></i>
                <span style={{ fontSize: '11.5px', color: 'var(--muted)' }}>{dc.t(m.eodDate)}</span>
                {m.eodAuto ? (
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '5px',
                      fontSize: '9.5px',
                      padding: '2px 8px',
                      borderRadius: '99px',
                      background: 'var(--l6)',
                      color: 'var(--muted)',
                    }}
                  >
                    <i className="ph ph-clock" style={{ fontSize: '10px' }}></i>Auto-generated
                  </span>
                ) : null}
              </div>{' '}
              <div
                style={{ fontSize: '15px', fontWeight: '500', letterSpacing: '-0.01em', marginTop: '5px' }}
              >
                Daily Performance Report
              </div>{' '}
            </div>{' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '11px', flex: 'none' }}>
              {' '}
              <svg viewBox="0 0 36 36" style={{ width: '56px', height: '56px', transform: 'rotate(-90deg)' }}>
                {' '}
                <circle cx="18" cy="18" r="15" fill="none" stroke="var(--l8)" strokeWidth="2"></circle>{' '}
                <circle
                  cx="18"
                  cy="18"
                  r="15"
                  fill="none"
                  stroke={dc.a(m.eodDiscFg)}
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeDasharray={dc.a(m.eodDiscDash)}
                ></circle>{' '}
              </svg>{' '}
              <div>
                <div style={{ fontSize: '10.5px', color: 'var(--muted2)' }}>Discipline</div>
                <div
                  style={dc.css(`font-size:13px;font-weight:500;margin-top:2px;color:${dc.s(m.eodDiscFg)}`)}
                >
                  {dc.t(m.eodDiscWord)}
                </div>
                <div style={{ fontSize: '10px', color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}>
                  {dc.t(m.eodDisc)}/100
                </div>
              </div>{' '}
            </div>{' '}
          </div>{' '}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,150px),1fr))',
              gap: '12px',
            }}
          >
            {' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '13px 15px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '9px',
                  letterSpacing: '0.11em',
                  textTransform: 'uppercase',
                  color: 'var(--muted2)',
                  fontWeight: '600',
                }}
              >
                <i className="ph ph-chart-bar" style={{ fontSize: '12px' }}></i>Net P&L
              </div>
              <div
                style={dc.css(
                  `font-size:17px;font-weight:600;letter-spacing:-0.02em;font-variant-numeric:tabular-nums;color:${dc.s(m.eodNetFg)};margin-top:5px`,
                )}
              >
                {dc.t(m.eodNet)}
              </div>
            </div>{' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '13px 15px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '9px',
                  letterSpacing: '0.11em',
                  textTransform: 'uppercase',
                  color: 'var(--muted2)',
                  fontWeight: '600',
                }}
              >
                <i className="ph ph-target" style={{ fontSize: '12px' }}></i>Win Rate
              </div>
              <div
                style={{
                  fontSize: '17px',
                  fontWeight: '600',
                  letterSpacing: '-0.02em',
                  fontVariantNumeric: 'tabular-nums',
                  marginTop: '5px',
                }}
              >
                {dc.t(m.eodWr)}
              </div>
              <div
                style={{
                  fontSize: '10px',
                  color: 'var(--muted2)',
                  marginTop: '2px',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {dc.t(m.eodWrSub)}
              </div>
            </div>{' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '13px 15px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '9px',
                  letterSpacing: '0.11em',
                  textTransform: 'uppercase',
                  color: 'var(--muted2)',
                  fontWeight: '600',
                }}
              >
                <i className="ph ph-trophy" style={{ fontSize: '12px', color: 'var(--pos)' }}></i>Best Trade
              </div>
              <div
                style={{
                  fontSize: '17px',
                  fontWeight: '600',
                  letterSpacing: '-0.02em',
                  fontVariantNumeric: 'tabular-nums',
                  color: 'var(--pos)',
                  marginTop: '5px',
                }}
              >
                {dc.t(m.eodBest)}
              </div>
              <div style={{ fontSize: '10px', color: 'var(--muted2)', marginTop: '2px' }}>
                {dc.t(m.eodBestSym)}
              </div>
            </div>{' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '13px 15px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '9px',
                  letterSpacing: '0.11em',
                  textTransform: 'uppercase',
                  color: 'var(--muted2)',
                  fontWeight: '600',
                }}
              >
                <i className="ph ph-warning" style={{ fontSize: '12px', color: 'var(--neg)' }}></i>Worst Trade
              </div>
              <div
                style={{
                  fontSize: '17px',
                  fontWeight: '600',
                  letterSpacing: '-0.02em',
                  fontVariantNumeric: 'tabular-nums',
                  color: 'var(--neg)',
                  marginTop: '5px',
                }}
              >
                {dc.t(m.eodWorst)}
              </div>
              <div style={{ fontSize: '10px', color: 'var(--muted2)', marginTop: '2px' }}>
                {dc.t(m.eodWorstSym)}
              </div>
            </div>{' '}
          </div>{' '}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,300px),1fr))',
              gap: '16px',
            }}
          >
            {' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '14px 16px',
              }}
            >
              {' '}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '7px',
                  fontSize: '12px',
                  fontWeight: '500',
                }}
              >
                <i className="ph ph-target" style={{ fontSize: '13px', color: 'var(--acc-2)' }}></i>Win/Loss
                Distribution
              </div>{' '}
              {m.eodHasTrades ? (
                <>
                  {' '}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '18px', marginTop: '12px' }}>
                    {' '}
                    <svg
                      viewBox="0 0 36 36"
                      style={{ width: '120px', height: '120px', transform: 'rotate(-90deg)' }}
                    >
                      {' '}
                      <circle
                        cx="18"
                        cy="18"
                        r="14"
                        fill="none"
                        stroke="var(--neg)"
                        strokeWidth="5"
                      ></circle>{' '}
                      <circle
                        cx="18"
                        cy="18"
                        r="14"
                        fill="none"
                        stroke="var(--pos)"
                        strokeWidth="5"
                        strokeDasharray={dc.a(m.eodWinDash)}
                      ></circle>{' '}
                    </svg>{' '}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '9px' }}>
                      {' '}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span
                          style={{
                            width: '9px',
                            height: '9px',
                            borderRadius: '2px',
                            background: 'var(--pos)',
                          }}
                        ></span>
                        <span style={{ fontSize: '11.5px', color: 'var(--text2)' }}>Wins</span>
                        <span
                          style={{
                            fontSize: '12.5px',
                            fontWeight: '600',
                            fontVariantNumeric: 'tabular-nums',
                          }}
                        >
                          {dc.t(m.eodWinsN)}
                        </span>
                      </div>{' '}
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span
                          style={{
                            width: '9px',
                            height: '9px',
                            borderRadius: '2px',
                            background: 'var(--neg)',
                          }}
                        ></span>
                        <span style={{ fontSize: '11.5px', color: 'var(--text2)' }}>Losses</span>
                        <span
                          style={{
                            fontSize: '12.5px',
                            fontWeight: '600',
                            fontVariantNumeric: 'tabular-nums',
                          }}
                        >
                          {dc.t(m.eodLossesN)}
                        </span>
                      </div>{' '}
                    </div>{' '}
                  </div>{' '}
                </>
              ) : null}{' '}
              {m.eodNoTrades ? (
                <>
                  {' '}
                  <div
                    style={{
                      height: '140px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '11.5px',
                      color: 'var(--faint)',
                    }}
                  >
                    No trades to display
                  </div>{' '}
                </>
              ) : null}{' '}
            </div>{' '}
            <div
              style={{
                background: 'var(--surface)',
                border: '1px solid var(--card-line)',
                boxShadow: 'var(--shadow-card)',
                borderRadius: '16px',
                padding: '14px 16px',
              }}
            >
              {' '}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '7px',
                  fontSize: '12px',
                  fontWeight: '500',
                }}
              >
                <i className="ph ph-chart-bar" style={{ fontSize: '13px', color: 'var(--acc-2)' }}></i>P&L by
                Symbol
              </div>{' '}
              {m.eodHasSymbols ? (
                <>
                  {' '}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '12px' }}>
                    {' '}
                    {(m.eodSymbols ?? []).map((s, i159) => (
                      <Fragment key={i159}>
                        {' '}
                        <div>
                          {' '}
                          <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                            <span style={{ fontSize: '11.5px', color: 'var(--text2)', flex: '1' }}>
                              {dc.t(s?.symbol)}
                            </span>
                            <span
                              style={{
                                fontSize: '10px',
                                color: 'var(--muted2)',
                                fontVariantNumeric: 'tabular-nums',
                              }}
                            >
                              {dc.t(s?.trades)}
                            </span>
                            <span
                              style={dc.css(
                                `font-size:11.5px;font-weight:600;color:${dc.s(s?.fg)};font-variant-numeric:tabular-nums`,
                              )}
                            >
                              {dc.t(s?.pnl)}
                            </span>
                          </div>{' '}
                          <div
                            style={{
                              height: '4px',
                              borderRadius: '99px',
                              background: 'var(--l6)',
                              marginTop: '6px',
                              overflow: 'hidden',
                            }}
                          >
                            <div
                              style={dc.css(
                                `width:${dc.s(s?.w)};height:100%;border-radius:99px;background:${dc.s(s?.bg)}`,
                              )}
                            ></div>
                          </div>{' '}
                        </div>{' '}
                      </Fragment>
                    ))}{' '}
                  </div>{' '}
                </>
              ) : null}{' '}
              {m.eodNoSymbols ? (
                <>
                  {' '}
                  <div
                    style={{
                      height: '140px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '11.5px',
                      color: 'var(--faint)',
                    }}
                  >
                    No symbol data
                  </div>{' '}
                </>
              ) : null}{' '}
            </div>{' '}
          </div>{' '}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,160px),1fr))',
              gap: '12px',
            }}
          >
            {' '}
            {(m.eodCompliance ?? []).map((c, i160) => (
              <Fragment key={i160}>
                {' '}
                <div
                  style={{
                    background: 'var(--surface)',
                    border: '1px solid var(--card-line)',
                    boxShadow: 'var(--shadow-card)',
                    borderRadius: '16px',
                    padding: '13px 15px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '11px',
                  }}
                >
                  <i
                    className={`ph ${dc.s(c?.icon)}`}
                    style={dc.css(`font-size:17px;color:${dc.s(c?.c)};flex:none`)}
                  ></i>
                  <div style={{ minWidth: '0' }}>
                    <div style={{ fontSize: '10.5px', color: 'var(--muted2)' }}>{dc.t(c?.k)}</div>
                    <div
                      style={{
                        fontSize: '12.5px',
                        fontWeight: '500',
                        marginTop: '2px',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      {dc.t(c?.v)}
                    </div>
                  </div>
                </div>{' '}
              </Fragment>
            ))}{' '}
          </div>{' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px',
            }}
          >
            {' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '7px',
                fontSize: '12.5px',
                fontWeight: '500',
              }}
            >
              <i className="ph ph-brain" style={{ fontSize: '15px', color: 'var(--acc-2)' }}></i>AI Analysis
            </div>{' '}
            <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '3px' }}>
              AI-generated performance review and coaching
            </div>{' '}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '9px', marginTop: '11px' }}>
              {' '}
              {(m.eodSummaryParas ?? []).map((p, i161) => (
                <Fragment key={i161}>
                  {' '}
                  <div
                    style={{
                      fontSize: '12px',
                      color: 'var(--text-mid)',
                      lineHeight: '1.65',
                      maxWidth: '88ch',
                    }}
                  >
                    {dc.t(p?.t)}
                  </div>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
          </div>{' '}
          {m.eodHasTips ? (
            <>
              {' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                }}
              >
                {' '}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '7px',
                    fontSize: '12.5px',
                    fontWeight: '600',
                  }}
                >
                  <i className="ph ph-lightbulb" style={{ fontSize: '14px', color: 'var(--amb)' }}></i>
                  Improvement Tips
                </div>{' '}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '9px', marginTop: '11px' }}>
                  {' '}
                  {(m.eodTips ?? []).map((t, i162) => (
                    <Fragment key={i162}>
                      {' '}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: '11px',
                          padding: '11px 13px',
                          borderRadius: '11px',
                          background: 'var(--l3)',
                          border: '1px solid var(--l8)',
                        }}
                      >
                        {' '}
                        <span
                          style={{
                            width: '22px',
                            height: '22px',
                            borderRadius: '50%',
                            background: 'color-mix(in srgb, var(--acc-fill) 20%, transparent)',
                            color: 'var(--acc)',
                            fontSize: '10.5px',
                            fontWeight: '600',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flex: 'none',
                          }}
                        >
                          {dc.t(t?.n)}
                        </span>{' '}
                        <span style={{ fontSize: '11.5px', color: 'var(--text2)', lineHeight: '1.6' }}>
                          {dc.t(t?.t)}
                        </span>{' '}
                      </div>{' '}
                    </Fragment>
                  ))}{' '}
                </div>{' '}
              </div>{' '}
            </>
          ) : null}{' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px',
            }}
          >
            {' '}
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
              {' '}
              <div
                style={{
                  flex: '1',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '7px',
                  fontSize: '12.5px',
                  fontWeight: '600',
                }}
              >
                <i className="ph ph-target" style={{ fontSize: '14px', color: 'var(--acc-2)' }}></i>Strategy
                Plan vs Execution
              </div>{' '}
              <div style={{ textAlign: 'right', flex: 'none' }}>
                <div
                  style={dc.css(
                    `font-size:17px;font-weight:700;color:${dc.s(m.eodAdherenceFg)};font-variant-numeric:tabular-nums`,
                  )}
                >
                  {dc.t(m.eodAdherence)}
                </div>
                <div style={{ fontSize: '9.5px', color: 'var(--muted2)' }}>Plan Adherence</div>
              </div>{' '}
            </div>{' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,200px),1fr))',
                gap: '16px',
                marginTop: '14px',
                alignItems: 'start',
              }}
            >
              {' '}
              <div>
                {' '}
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Planned Today
                </div>{' '}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '8px' }}>
                  {' '}
                  {m.eodHasPlanned ? (
                    <>
                      {' '}
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                        {' '}
                        {(m.eodPlanned ?? []).map((p, i163) => (
                          <Fragment key={i163}>
                            {' '}
                            <div
                              style={dc.css(
                                `display:flex;align-items:center;gap:8px;padding:6px 9px;border-radius:8px;background:${dc.s(p?.bg)};color:${dc.s(p?.fg)};font-size:11.5px`,
                              )}
                            >
                              <i
                                className={`ph ${dc.s(p?.icon)}`}
                                style={{ fontSize: '13px', flex: 'none' }}
                              ></i>
                              <span
                                style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                              >
                                {dc.t(p?.name)}
                              </span>
                            </div>{' '}
                          </Fragment>
                        ))}{' '}
                      </div>{' '}
                    </>
                  ) : null}{' '}
                </div>{' '}
              </div>{' '}
              <div>
                {' '}
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Actually Used
                </div>{' '}
                {m.eodHasUsed ? (
                  <>
                    {' '}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '8px' }}>
                      {' '}
                      {(m.eodUsed ?? []).map((u, i164) => (
                        <Fragment key={i164}>
                          {' '}
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              padding: '6px 9px',
                              borderRadius: '8px',
                              background: 'var(--l5)',
                              fontSize: '11.5px',
                            }}
                          >
                            <i
                              className={`ph ${dc.s(u?.icon)}`}
                              style={dc.css(`font-size:13px;color:${dc.s(u?.iconFg)};flex:none`)}
                            ></i>
                            <span
                              style={{
                                flex: '1',
                                minWidth: '0',
                                color: 'var(--text2)',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {dc.t(u?.name)}
                            </span>
                            <span
                              style={dc.css(
                                `font-size:10.5px;color:${dc.s(u?.pnlFg)};font-variant-numeric:tabular-nums;flex:none`,
                              )}
                            >
                              {dc.t(u?.pnl)}
                            </span>
                          </div>{' '}
                        </Fragment>
                      ))}{' '}
                    </div>{' '}
                  </>
                ) : null}{' '}
                {m.eodNoUsed ? (
                  <>
                    {' '}
                    <div
                      style={{
                        fontSize: '11px',
                        color: 'var(--faint)',
                        fontStyle: 'italic',
                        marginTop: '8px',
                      }}
                    >
                      No tagged trades
                    </div>{' '}
                  </>
                ) : null}{' '}
              </div>{' '}
              <div>
                {' '}
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Deviations
                </div>{' '}
                {m.eodAsPlanned ? (
                  <>
                    {' '}
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '6px 9px',
                        borderRadius: '8px',
                        background: 'color-mix(in srgb, var(--pos) 10%, transparent)',
                        color: 'var(--pos)',
                        fontSize: '11px',
                        marginTop: '8px',
                      }}
                    >
                      <i className="ph ph-check-circle" style={{ fontSize: '13px' }}></i>Traded as planned
                    </div>{' '}
                  </>
                ) : null}{' '}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: '8px' }}>
                  {' '}
                  {(m.eodDeviations ?? []).map((d, i165) => (
                    <Fragment key={i165}>
                      {' '}
                      <div
                        style={dc.css(
                          `display:flex;align-items:center;gap:8px;padding:6px 9px;border-radius:8px;background:${dc.s(d?.bg)};color:${dc.s(d?.fg)};font-size:11px`,
                        )}
                      >
                        <i className={`ph ${dc.s(d?.icon)}`} style={{ fontSize: '12px', flex: 'none' }}></i>
                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {dc.t(d?.label)}
                        </span>
                      </div>{' '}
                    </Fragment>
                  ))}{' '}
                </div>{' '}
              </div>{' '}
            </div>{' '}
          </div>{' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '16px 18px',
            }}
          >
            {' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '7px',
                fontSize: '12.5px',
                fontWeight: '500',
              }}
            >
              <i className="ph ph-skip-forward" style={{ fontSize: '15px', color: 'var(--amb)' }}></i>
              Preparation Bypass Audit
            </div>{' '}
            <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '3px' }}>
              {'Correlation between skipping preparation and daily P&L over the last '}
              {dc.t(m.eodSessionCount)}
              {' sessions'}
            </div>{' '}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit,minmax(min(100%,150px),1fr))',
                gap: '10px',
                marginTop: '14px',
              }}
            >
              {' '}
              <div
                style={{
                  border: '1px solid var(--l8)',
                  borderRadius: '11px',
                  background: 'var(--l3)',
                  padding: '11px 13px',
                }}
              >
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Bypassed Sessions
                </div>
                <div
                  style={{
                    fontSize: '17px',
                    fontWeight: '600',
                    color: 'var(--amb)',
                    marginTop: '4px',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  {dc.t(m.eodBypassCount)}
                </div>
                <div style={{ fontSize: '10px', color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}>
                  {'of '}
                  {dc.t(m.eodSessionCount)}
                  {' total'}
                </div>
              </div>{' '}
              <div
                style={{
                  border: '1px solid var(--l8)',
                  borderRadius: '11px',
                  background: 'var(--l3)',
                  padding: '11px 13px',
                }}
              >
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Avg P&L — Bypassed
                </div>
                <div
                  style={dc.css(
                    `font-size:17px;font-weight:600;color:${dc.s(m.eodAvgBFg)};margin-top:4px;font-variant-numeric:tabular-nums`,
                  )}
                >
                  {dc.t(m.eodAvgB)}
                </div>
              </div>{' '}
              <div
                style={{
                  border: '1px solid var(--l8)',
                  borderRadius: '11px',
                  background: 'var(--l3)',
                  padding: '11px 13px',
                }}
              >
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Avg P&L — Prepared
                </div>
                <div
                  style={dc.css(
                    `font-size:17px;font-weight:600;color:${dc.s(m.eodAvgPFg)};margin-top:4px;font-variant-numeric:tabular-nums`,
                  )}
                >
                  {dc.t(m.eodAvgP)}
                </div>
              </div>{' '}
              <div
                style={{
                  border: '1px solid var(--l8)',
                  borderRadius: '11px',
                  background: 'var(--l3)',
                  padding: '11px 13px',
                }}
              >
                <div
                  style={{
                    fontSize: '9px',
                    letterSpacing: '0.11em',
                    textTransform: 'uppercase',
                    color: 'var(--muted2)',
                    fontWeight: '600',
                  }}
                >
                  Preparation Advantage
                </div>
                <div
                  style={dc.css(
                    `font-size:17px;font-weight:600;color:${dc.s(m.eodDeltaFg)};margin-top:4px;font-variant-numeric:tabular-nums`,
                  )}
                >
                  {dc.t(m.eodDelta)}
                </div>
                <div style={{ fontSize: '10px', color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}>
                  {dc.t(m.eodDeltaSub)}
                </div>
              </div>{' '}
            </div>{' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '10px',
                padding: '11px 13px',
                borderRadius: '11px',
                border: '1px solid var(--l8)',
                background: 'var(--l3)',
                marginTop: '12px',
              }}
            >
              <i
                className={`ph ${dc.s(m.eodInsightIcon)}`}
                style={dc.css(`font-size:14px;color:${dc.s(m.eodInsightFg)};flex:none;margin-top:1px`)}
              ></i>
              <span style={{ fontSize: '11.5px', color: 'var(--text2)', lineHeight: '1.6' }}>
                {dc.t(m.eodInsight)}
              </span>
            </div>{' '}
            <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '14px' }}>
              {dc.t(m.eodPriceNote)}
            </div>{' '}
            <div
              style={{
                height: '260px',
                marginTop: '9px',
                border: '1px solid var(--l8)',
                borderRadius: '11px',
                overflow: 'hidden',
                position: 'relative',
              }}
            >
              {' '}
              <PfTvChart
                symbol={dc.a(m.eodSym)}
                interval="15"
                theme={dc.a(m.tvTheme)}
                mode="review"
                markers={dc.a(m.eodMarkers)}
                style={{ position: 'absolute', inset: '0' }}
              ></PfTvChart>{' '}
            </div>{' '}
            <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '14px' }}>
              {dc.t(m.eodChartNote)}
            </div>{' '}
            <div
              style={{
                height: '120px',
                display: 'flex',
                alignItems: 'flex-end',
                gap: '5px',
                marginTop: '9px',
              }}
            >
              {' '}
              {(m.eodChart ?? []).map((c, i166) => (
                <Fragment key={i166}>
                  {' '}
                  <div
                    style={{
                      flex: '1',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <div
                      style={dc.css(
                        `width:100%;max-width:16px;margin:0 auto;height:${dc.s(c?.h)};border-radius:3px 3px 0 0;background:${dc.s(c?.bg)}`,
                      )}
                    ></div>
                  </div>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '5px' }}>
              {' '}
              {(m.eodTicks ?? []).map((t, i167) => (
                <Fragment key={i167}>
                  <span
                    style={{
                      fontSize: '9px',
                      color: 'var(--faint)',
                      whiteSpace: 'nowrap',
                      fontVariantNumeric: 'tabular-nums',
                    }}
                  >
                    {dc.t(t?.label)}
                  </span>
                </Fragment>
              ))}{' '}
            </div>{' '}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                marginTop: '10px',
                paddingTop: '9px',
                borderTop: '1px solid var(--l6)',
                flexWrap: 'wrap',
              }}
            >
              {' '}
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '10px',
                  color: 'var(--muted2)',
                }}
              >
                <span
                  style={{ width: '9px', height: '9px', borderRadius: '2px', background: 'var(--amb)' }}
                ></span>
                Bypassed preparation
              </span>{' '}
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '10px',
                  color: 'var(--muted2)',
                }}
              >
                <span
                  style={{ width: '9px', height: '9px', borderRadius: '2px', background: 'var(--pos)' }}
                ></span>
                Prepared — profitable
              </span>{' '}
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '10px',
                  color: 'var(--muted2)',
                }}
              >
                <span
                  style={{ width: '9px', height: '9px', borderRadius: '2px', background: 'var(--neg)' }}
                ></span>
                Prepared — loss
              </span>{' '}
            </div>{' '}
            {m.eodHasBypass ? (
              <>
                {' '}
                <div style={{ marginTop: '14px' }}>
                  {' '}
                  <div
                    style={{
                      fontSize: '9px',
                      letterSpacing: '0.11em',
                      textTransform: 'uppercase',
                      color: 'var(--muted2)',
                      fontWeight: '600',
                    }}
                  >
                    Bypassed Sessions Detail
                  </div>{' '}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '7px', marginTop: '8px' }}>
                    {' '}
                    {(m.eodBypassRows ?? []).map((b, i168) => (
                      <Fragment key={i168}>
                        {' '}
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '9px 12px',
                            borderRadius: '11px',
                            border: '1px solid color-mix(in srgb, var(--amb) 20%, transparent)',
                            background: 'color-mix(in srgb, var(--amb) 5%, transparent)',
                          }}
                        >
                          {' '}
                          <i
                            className="ph ph-skip-forward"
                            style={{ fontSize: '13px', color: 'var(--amb)', flex: 'none' }}
                          ></i>{' '}
                          <div style={{ flex: '1', minWidth: '0' }}>
                            <div style={{ fontSize: '11.5px', fontWeight: '500' }}>{dc.t(b?.date)}</div>
                            <div style={{ fontSize: '10px', color: 'var(--muted2)' }}>{dc.t(b?.at)}</div>
                          </div>{' '}
                          <div style={{ textAlign: 'right' }}>
                            <div style={{ fontSize: '9.5px', color: 'var(--muted2)' }}>Trades</div>
                            <div
                              style={{
                                fontSize: '11px',
                                fontWeight: '500',
                                fontVariantNumeric: 'tabular-nums',
                              }}
                            >
                              {dc.t(b?.trades)}
                            </div>
                          </div>{' '}
                          <div style={{ textAlign: 'right' }}>
                            <div style={{ fontSize: '9.5px', color: 'var(--muted2)' }}>Win Rate</div>
                            <div
                              style={{
                                fontSize: '11px',
                                fontWeight: '500',
                                fontVariantNumeric: 'tabular-nums',
                              }}
                            >
                              {dc.t(b?.wr)}
                            </div>
                          </div>{' '}
                          <div style={{ textAlign: 'right' }}>
                            <div style={{ fontSize: '9.5px', color: 'var(--muted2)' }}>P&L</div>
                            <div
                              style={dc.css(
                                `font-size:11px;font-weight:500;color:${dc.s(b?.pnlFg)};font-variant-numeric:tabular-nums`,
                              )}
                            >
                              {dc.t(b?.pnl)}
                            </div>
                          </div>{' '}
                        </div>{' '}
                      </Fragment>
                    ))}{' '}
                  </div>{' '}
                </div>{' '}
              </>
            ) : null}{' '}
          </div>{' '}
          {m.eodHasOverrides ? (
            <>
              {' '}
              <div
                style={{
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  boxShadow: 'var(--shadow-card)',
                  borderRadius: '16px',
                  padding: '16px 18px',
                }}
              >
                {' '}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '7px',
                    fontSize: '12.5px',
                    fontWeight: '500',
                  }}
                >
                  <i className="ph ph-shield-warning" style={{ fontSize: '15px', color: 'var(--neg)' }}></i>
                  Red Flag Override Events
                </div>{' '}
                <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '3px' }}>
                  {'Sessions where red flags were detected but the trader chose to proceed — '}
                  {dc.t(m.eodOverrideCount)}
                </div>{' '}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '10px',
                    padding: '11px 13px',
                    borderRadius: '11px',
                    border: '1px solid color-mix(in srgb, var(--neg) 20%, transparent)',
                    background: 'color-mix(in srgb, var(--neg-fill) 5%, transparent)',
                    marginTop: '12px',
                  }}
                >
                  <i
                    className="ph ph-eye"
                    style={{ fontSize: '14px', color: 'var(--neg)', flex: 'none', marginTop: '1px' }}
                  ></i>
                  <span style={{ fontSize: '11px', color: 'var(--text2)', lineHeight: '1.6' }}>
                    These sessions represent moments where your system detected risk conditions but you chose
                    to trade anyway. Review the flags and outcomes below to identify patterns in your override
                    decisions.
                  </span>
                </div>{' '}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '11px' }}>
                  {' '}
                  {(m.eodOverrides ?? []).map((o, i169) => (
                    <Fragment key={i169}>
                      {' '}
                      <div
                        style={{
                          border: '1px solid color-mix(in srgb, var(--neg) 15%, transparent)',
                          background: 'color-mix(in srgb, var(--neg-fill) 5%, transparent)',
                          borderRadius: '11px',
                          padding: '11px 13px',
                          display: 'flex',
                          alignItems: 'flex-start',
                          gap: '12px',
                        }}
                      >
                        {' '}
                        <div style={{ flex: '1', minWidth: '0' }}>
                          {' '}
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <i
                              className="ph ph-shield-warning"
                              style={{ fontSize: '13px', color: 'var(--neg)', flex: 'none' }}
                            ></i>
                            <span style={{ fontSize: '11.5px', fontWeight: '500' }}>{dc.t(o?.date)}</span>
                          </div>{' '}
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', marginTop: '7px' }}>
                            {' '}
                            {(o?.flags ?? []).map((f, i170) => (
                              <Fragment key={i170}>
                                <span
                                  style={{
                                    fontSize: '9.5px',
                                    padding: '2px 8px',
                                    borderRadius: '99px',
                                    border: '1px solid color-mix(in srgb, var(--neg) 30%, transparent)',
                                    color: 'var(--neg)',
                                  }}
                                >
                                  {dc.t(f?.label)}
                                </span>
                              </Fragment>
                            ))}{' '}
                          </div>{' '}
                          {o?.hasReason ? (
                            <>
                              {' '}
                              <div
                                style={{
                                  fontSize: '10.5px',
                                  color: 'var(--muted2)',
                                  fontStyle: 'italic',
                                  marginTop: '7px',
                                }}
                              >
                                {dc.t(o?.reason)}
                              </div>{' '}
                            </>
                          ) : null}{' '}
                        </div>{' '}
                        <div style={{ textAlign: 'right', flex: 'none' }}>
                          <div style={{ fontSize: '9.5px', color: 'var(--muted2)' }}>Outcome</div>
                          <div
                            style={dc.css(
                              `font-size:12.5px;font-weight:500;color:${dc.s(o?.pnlFg)};margin-top:2px;font-variant-numeric:tabular-nums`,
                            )}
                          >
                            {dc.t(o?.pnl)}
                          </div>
                          <div
                            style={{
                              fontSize: '9.5px',
                              color: 'var(--muted2)',
                              fontVariantNumeric: 'tabular-nums',
                            }}
                          >
                            {dc.t(o?.trades)}
                          </div>
                        </div>{' '}
                      </div>{' '}
                    </Fragment>
                  ))}{' '}
                </div>{' '}
              </div>{' '}
            </>
          ) : null}{' '}
        </div>{' '}
      </div>
    </div>
  );
}
